<template>
  <a
    v-if="isUrl || !href"
    :href="href"
    :target="target"
    :class="['btn', 'btn-' + color, btnBlock, disabled]"
    @click="$emit('click', $event)"
  >
    <slot v-if="!loading"></slot>
    <span v-if="loading">{{ loadingText }}</span>
  </a>

  <router-link
    v-else
    :to="href"
    :target="target"
    active-class=""
    :class="['btn', 'btn-' + color, btnBlock, disabled]"
    @click="$emit('click', $event)"
  >
    <slot v-if="!loading"></slot>
    <span v-if="loading">{{ loadingText }}</span>
  </router-link>
</template>

<script>
export default {
  name: "button-link",
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_self",
      validate: val => {
        return ["_self", "_blank"].indexOf(val) !== -1;
      }
    },
    color: {
      type: String,
      default: "default"
    },
    block: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: "Aguarde..."
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabled() {
      return this.loading === true ? "disabled" : "";
    },
    btnBlock() {
      return this.block ? "btn-block" : "";
    },
    isUrl() {
      let expression = /[-a-zA-Z0-9@:%_.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_.~#?&//=]*)?/gi;
      let regex = new RegExp(expression);

      return regex.test(this.href);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Buttons/ButtonLink.vue